import {Component, EventEmitter, Injector, Input, Output, ViewChild} from '@angular/core';
import {NgModel} from '@angular/forms';

import {Company} from "../../models/company";
import {UserService} from "../../services/user/user.service";
import {StaffService} from "../../services/staff/staff.service";
import {CompanyService} from "../../services/company/company.service";
import {BaseComponent} from "../../components/base/base.component";
import {Router} from "@angular/router";
import Swal from "sweetalert2";

@Component({
    selector: 'app-register-staff',
    templateUrl: './register-staff.component.html',
    styleUrls: ['./register-staff.component.scss']
})
export class RegisterStaffComponent extends BaseComponent {

    @Input() idService: string | null = null;
    @Output('step') public stepEmit: EventEmitter<any> = new EventEmitter<any>();
    @Output('listOfSteps') public listOfStepsEmitter: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('email') email!: NgModel;
    @ViewChild('phone') phone!: NgModel;
    @ViewChild('nextButtonTerms') nextButtonTerms!: any;

    stepsStaff = [
        { id: 1, title: 'Benvenuto', text: '' },
        { id: 2, title: 'Ruolo', text: '' },
        { id: 3, title: 'Dati personali', text: '' },
        { id: 4, title: 'Documenti', text: '' },
        { id: 5, title: 'Credenziali', text: '' },
        { id: 6, title: 'Termini e condizioni', text: '' },
        { id: 7, title: 'Verifica OTP', text: '' },
        { id: 8, title: 'Congratulazioni', text: '' }
    ];

    private readonly STEP_STORAGE_KEY = 'register_staff_step';
    private readonly DATA_STORAGE_KEY = 'register_staff';

    termsAndConditionAccepted: boolean = false;
    privacyAccepted: boolean = false;
    companyRulesAccepted: boolean = false;

    company: Company | undefined;
    companyId: string | undefined;
    companyRules: string | undefined;
    OTPCode: string = '';

    showPassword: boolean = false;
    showConfirmPassword: boolean = false;
    showTermsError = false;

    roles = [
        {
            value: 'mister',
            label: 'Mister Allenatore',
            icon: 'bi bi-megaphone-fill',
            description: 'Gestione tecnica della squadra'
        },
        {
            value: 'accompagnatore',
            label: 'Accompagnatore',
            icon: 'bi bi-people-fill',
            description: 'Supporto organizzativo e gestione del gruppo'
        },
        {
            value: 'staff',
            label: 'Staff generico',
            icon: 'bi bi-person-workspace',
            description: 'Supporto operativo alle attività'
        }
    ];

    newStaff: any = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
        role: '',
        id_front_file: null,
        id_back_file: null,
        cf_front_file: null,
        cf_back_file: null,
        license_file: null,
        id_expiry: '',
        cf_expiry: '',
        license_expiry: '',
    };

    documentUrlFront: string = '';
    documentUrlBack: string = '';
    cfDocumentUrlFront: string = '';
    cfDocumentUrlBack: string = '';
    licenseDocumentUrl: string = '';

    isProcessing = false;
    currentStep = 1;

    @ViewChild('idFrontInput') idFrontInput!: any;
    @ViewChild('idBackInput') idBackInput!: any;
    @ViewChild('cfFrontInput') cfFrontInput!: any;
    @ViewChild('cfBackInput') cfBackInput!: any;
    @ViewChild('licenseInput') licenseInput!: any;

    constructor(
        public serviceInjector: Injector,
        public router: Router,
        public companyService: CompanyService,
        public userService: UserService,
        public staffService: StaffService) {
        super(serviceInjector);
    }

    async ngOnInit(): Promise<void> {
        this.restoreFormData();

        const savedStep = localStorage.getItem(this.STEP_STORAGE_KEY);
        if (savedStep) {
            const parsed = parseInt(savedStep, 10);
            if (!isNaN(parsed) && parsed >= 1 && parsed <= this.stepsStaff.length) {
                this.currentStep = parsed;
            }
        }

        this.listOfStepsEmitter.emit(this.stepsStaff);
        this.stepEmit.emit(this.currentStep);

        this.company = await this.companyService.getCompanyFromDomain(window.location.hostname);
        this.companyId = this.company?.id;
        this.companyRules = this.company?.rulesUrl;
    }

    private restoreFormData(): void {
        const saved = localStorage.getItem(this.DATA_STORAGE_KEY);
        if (!saved) return;
        try {
            const data = JSON.parse(saved);
            if (data.newStaff) {
                Object.assign(this.newStaff, data.newStaff);
            }
            if (data.termsAndConditionAccepted !== undefined) {
                this.termsAndConditionAccepted = data.termsAndConditionAccepted;
            }
            if (data.privacyAccepted !== undefined) {
                this.privacyAccepted = data.privacyAccepted;
            }
            if (data.companyRulesAccepted !== undefined) {
                this.companyRulesAccepted = data.companyRulesAccepted;
            }

            if (data.documentUrlFront) this.documentUrlFront = data.documentUrlFront;
            if (data.documentUrlBack) this.documentUrlBack = data.documentUrlBack;
            if (data.cfDocumentUrlFront) this.cfDocumentUrlFront = data.cfDocumentUrlFront;
            if (data.cfDocumentUrlBack) this.cfDocumentUrlBack = data.cfDocumentUrlBack;
            if (data.licenseDocumentUrl) this.licenseDocumentUrl = data.licenseDocumentUrl;
        } catch {
            /* ignore */
        }
    }

    persistForm() {
        const copy = {...this.newStaff};
        delete copy.id_front_file;
        delete copy.id_back_file;
        delete copy.cf_front_file;
        delete copy.cf_back_file;
        delete copy.license_file;
        delete copy.password;
        delete copy.confirmPassword;

        localStorage.setItem(this.DATA_STORAGE_KEY, JSON.stringify({
            newStaff: copy,
            termsAndConditionAccepted: this.termsAndConditionAccepted,
            privacyAccepted: this.privacyAccepted,
            companyRulesAccepted: this.companyRulesAccepted,
            documentUrlFront: this.documentUrlFront,
            documentUrlBack: this.documentUrlBack,
            cfDocumentUrlFront: this.cfDocumentUrlFront,
            cfDocumentUrlBack: this.cfDocumentUrlBack,
            licenseDocumentUrl: this.licenseDocumentUrl,
        }));
    }

    chooseDocument(event: any, field: string) {
        const file = event.target.files && event.target.files[0];
        if (file) {
            this.newStaff[field] = file;
            this.persistForm();
        }
    }

    onDocumentDrop(event: any, field: string) {
        event.preventDefault();
        const file = event.dataTransfer?.files?.[0];
        if (file) {
            this.newStaff[field] = file;
            this.persistForm();
        }
    }

    isPasswordComplexEnough(): boolean {
        const p = this.newStaff.password || '';
        const hasUpper = /[A-Z]/.test(p);
        const hasLower = /[a-z]/.test(p);
        const hasNumber = /[0-9]/.test(p);
        const hasSpecial = /[\W_]/.test(p);
        const hasMinLength = p.length >= 8;
        return hasUpper && hasLower && hasNumber && hasSpecial && hasMinLength;
    }

    isPasswordValid(): boolean {
        if (!this.newStaff.password || !this.newStaff.confirmPassword) return false;
        return this.isPasswordComplexEnough() && this.newStaff.password === this.newStaff.confirmPassword;
    }

    needsLicense(): boolean {
        return this.newStaff.role === 'mister' || this.newStaff.role === 'accompagnatore';
    }

    private isExpiryValid(expiryField: string): boolean {
        const expiry = this.newStaff[expiryField];
        if (!expiry) return false;
        const d = new Date(expiry);
        if (isNaN(d.getTime())) return false;
        return d.getTime() > Date.now();
    }

    isRoleValid(): boolean {
        return !!this.newStaff.role;
    }

    isPersonalInfoValid(): boolean {
        return (
            this.newStaff.firstName?.trim() !== '' &&
            this.newStaff.lastName?.trim() !== '' &&
            this.newStaff.email?.trim() !== '' &&
            (this.email?.valid === true || !this.email) &&
            this.newStaff.phone?.trim() !== '' &&
            (this.phone?.valid === true || !this.phone)
        );
    }

    isDocumentsValid(): boolean {
        const idValid = !!(
            this.newStaff.id_front_file &&
            this.newStaff.id_back_file &&
            this.isExpiryValid('id_expiry')
        );
        const cfValid = !!(
            this.newStaff.cf_front_file &&
            this.newStaff.cf_back_file &&
            this.isExpiryValid('cf_expiry')
        );

        if (!idValid || !cfValid) return false;

        if (this.needsLicense()) {
            return !!(
                this.newStaff.license_file &&
                this.isExpiryValid('license_expiry')
            );
        }

        return true;
    }

    isTermsValid(): boolean {
        return (
            this.termsAndConditionAccepted &&
            this.privacyAccepted &&
            this.companyRulesAccepted
        );
    }

    isOtpValid(): boolean {
        return (this.OTPCode?.trim().length ?? 0) >= 6;
    }

    async uploadDocument(file: File): Promise<string | null> {
        if (!file) return null;

        const formData = new FormData();
        formData.append('file', file);

        const { success, data } = await this.userService.uploadUser(formData);
        if (success) return data;
        return null;
    }

    async uploadDocuments(): Promise<boolean> {
        this.documentUrlFront = await this.uploadDocument(this.newStaff.id_front_file) || '';
        this.documentUrlBack = await this.uploadDocument(this.newStaff.id_back_file) || '';
        this.cfDocumentUrlFront = await this.uploadDocument(this.newStaff.cf_front_file) || '';
        this.cfDocumentUrlBack = await this.uploadDocument(this.newStaff.cf_back_file) || '';

        if (!this.documentUrlFront || !this.documentUrlBack || !this.cfDocumentUrlFront || !this.cfDocumentUrlBack) {
            return false;
        }

        if (this.needsLicense()) {
            this.licenseDocumentUrl = await this.uploadDocument(this.newStaff.license_file) || '';
            if (!this.licenseDocumentUrl) return false;
        } else {
            this.licenseDocumentUrl = '';
        }

        this.persistForm();
        return true;
    }

    async sendRegistrationStaff(): Promise<boolean> {
        const staffToRegister = {
            firstName: this.newStaff.firstName,
            lastName: this.newStaff.lastName,
            email: this.newStaff.email,
            phone: this.newStaff.phone,
            password: this.newStaff.password,
            subtype: this.newStaff.role,
            companyId: this.companyId,
            documentUrlFront: this.documentUrlFront,
            documentUrlBack: this.documentUrlBack,
            cfDocumentUrlFront: this.cfDocumentUrlFront,
            cfDocumentUrlBack: this.cfDocumentUrlBack,
            licenseDocumentUrl: this.licenseDocumentUrl || undefined,
            idExpiry: this.newStaff.id_expiry,
            cfExpiry: this.newStaff.cf_expiry,
            licenseExpiry: this.newStaff.license_expiry || undefined,
            acceptTerms: new Date().toISOString(),
            acceptPrivacy: new Date().toISOString(),
            acceptCompanyRules: new Date().toISOString(),
        };

        const response: any = await this.staffService.register(staffToRegister);

        if (response?.success) {
            return true;
        }

        if (response?.code === 'USER_ALREADY_EXIST') {
            Swal.fire({
                icon: 'error',
                title: "Errore, email già registrata con un altro utente!"
            });
        } else {
            Swal.fire({
                icon: 'error',
                title: "Errore durante la creazione dell'utente, riprovare"
            });
        }
        return false;
    }

    async nextStep() {
        if (this.currentStep >= this.stepsStaff.length) {
            return;
        }

        if (this.currentStep === 2 && !this.isRoleValid()) {
            return;
        }

        if (this.currentStep === 3 && !this.isPersonalInfoValid()) {
            return;
        }

        if (this.currentStep === 5 && !this.isPasswordValid()) {
            return;
        }

        if (this.currentStep === 4) {
            if (!this.isDocumentsValid()) return;
            this.isProcessing = true;
            this.showSpinner();
            const uploaded = await this.uploadDocuments();
            this.showSpinner();
            this.isProcessing = false;
            if (!uploaded) {
                Swal.fire({
                    icon: 'error',
                    title: "Errore durante il caricamento dei documenti, riprovare"
                });
                return;
            }
        }

        if (this.currentStep === 6) {
            if (!this.isTermsValid()) {
                this.showTermsError = true;
                return;
            } else {
                this.showTermsError = false;
            }
            if (this.nextButtonTerms?.nativeElement) {
                this.nextButtonTerms.nativeElement.disabled = true;
            }
            const registered = await this.sendRegistrationStaff();
            if (!registered) {
                if (this.nextButtonTerms?.nativeElement) {
                    this.nextButtonTerms.nativeElement.disabled = false;
                }
                return;
            }
        }

        this.setStep(this.currentStep + 1);
    }

    setStep(step: number) {
        this.currentStep = step;
        try {
            localStorage.setItem(this.STEP_STORAGE_KEY, this.currentStep.toString());
        } catch (e) { /* ignore */
        }
        this.persistForm();

        if (this.currentStep >= this.stepsStaff.length) {
            localStorage.removeItem(this.STEP_STORAGE_KEY);
            localStorage.removeItem(this.DATA_STORAGE_KEY);
        }
        this.stepEmit.emit(step);
    }

    previousStep() {
        if (this.currentStep <= 1) {
            return;
        }
        this.setStep(this.currentStep - 1);
    }

    async checkOTP(otp: string, email: string) {
        const response = await this.userService.checkOTP(otp, email);
        if (response?.success) {
            localStorage.removeItem(this.STEP_STORAGE_KEY);
            localStorage.removeItem(this.DATA_STORAGE_KEY);
            this.setStep(this.stepsStaff.length);
        } else {
            Swal.fire({icon: 'error', title: 'Non è stato possibile verificare il codice OTP inserito'});
        }
    }

    selectRole(value: string) {
        this.newStaff.role = value;
        this.persistForm();
    }

    backToLogin() {
        this.router.navigate(['/login'])
    }
}
